import { useEffect } from 'react';
import { redirectToLoginSync } from '../auth/authClient.js';
import { t } from '../i18n/es.js';

export function LoginPage(): JSX.Element {
  useEffect(() => {
    redirectToLoginSync('/');
  }, []);
  return <div className="p-6 text-sm text-slate-600">{t.login.redirecting}</div>;
}
